export default "__VITE_ASSET__q$VcVagR56VeUabCjrAt$A__"